import React from 'react';
import PropTypes from 'prop-types';
import { favoriteAction, unfavoriteAction } from './actions';

export default class FavoriteDesignerActuator extends React.Component {
    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
    }

    onClick() {
        if (!this.props.isReady) return;
        this.context.executeAction(
            this.props.isFavorite ? unfavoriteAction : favoriteAction,
            { url: this.props.xhrUrl, csrfToken: window.REQUEST_TOKENS.DESIGN_UPDATE_LIKE_STATUS }, // FIXME: embed csrf in url
        );
    }

    render() {
        return (
            <button onClick={this.onClick} className="icon-button">
                {this.props.children}
            </button>
        );
    }
}

FavoriteDesignerActuator.contextTypes = {
    executeAction: PropTypes.func,
};

FavoriteDesignerActuator.propTypes = {
    children: PropTypes.node.isRequired,
    isFavorite: PropTypes.bool.isRequired,
    xhrUrl: PropTypes.string.isRequired,
    isReady: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./src/js/apps/favorite-designer/FavoriteDesignerActuator.jsx